import { Button, makeStyles, Typography, Box } from '@material-ui/core';

import Collapse from '@material-ui/core/Collapse';
import { ChevronUp } from '@eduzz/houston-icons';
import { useState } from 'react';
import { CourseTheme } from 'assets/themes/Course';
import useImageFallback from 'hooks/useImageFallback';
import defaultImage from 'assets/img/avatar.png';
import { useAppSelector } from 'hooks/redux';

const useStyles = makeStyles<CourseTheme>((theme) => ({
  descriptionContainer: {
    '& *': {
      overflowWrap: 'break-word',
    },
    '& h4': {
      color: theme.variables.courseTheme.text,
    },
  },
  toggleContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    '& *[data-collapsed=false] .houston-icon': {
      transform: 'rotate(0deg)',
    },
    '& *[data-collapsed=true] .houston-icon': {
      transform: 'rotate(180deg)',
    },
  },
  toggleButton: {
    color: theme.variables.courseTheme.text,
    textTransform: 'capitalize',
    fontSize: 14,
    '& .houston-icon': {
      transition: '300ms',
      marginLeft: theme.spacing(3),
      color: theme.variables.courseTheme.text,
    },
  },
  authorContainer: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(4),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '& img': {
      width: 40,
      height: 40,
      borderRadius: 40,
    },
    '& h4': {
      marginLeft: theme.spacing(3),
      color: theme.variables.courseTheme.text,
      fontWeight: 600,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      width: '100%',
    },
  },
}));

const Description = () => {
  const [collapsed, setCollapsed] = useState(true);
  const course = useAppSelector((state) => state.course);
  const imageProps = useImageFallback(course?.author?.avatar, defaultImage);
  const classes = useStyles();

  const toggleCollapse = () => {
    setCollapsed((isCollapsed) => !isCollapsed);
  };

  const { description_color } = course.customizations;

  const renderDescription = (
    <>
      <div className={classes.authorContainer}>
        <img {...imageProps} alt={`Imagem do autor do curso`} />
        <Typography aria-label='Nome do autor do curso' variant='h4' id='informations-course-author-name'>
          {course.author.name}
        </Typography>
      </div>
      <div className={classes.descriptionContainer}>
        <Typography aria-label='Descrição do curso' variant='h4'>
          <div
            id='informations-course-description'
            style={description_color && { color: description_color }}
            dangerouslySetInnerHTML={{ __html: course.description }}
          />
        </Typography>
      </div>
    </>
  );

  if (course.description.length <= 768) {
    return <Box marginBottom={6}>{renderDescription}</Box>;
  }

  return (
    <>
      <Collapse in={!collapsed} collapsedSize={90}>
        {renderDescription}
      </Collapse>
      <div className={classes.toggleContainer}>
        <Button
          aria-label='Botão para visualizar toda a descrição do curso ou diminuir'
          id='information-btn-see-more'
          data-collapsed={collapsed}
          className={classes.toggleButton}
          onClick={toggleCollapse}
        >
          {collapsed ? 'ver mais ' : 'Ver menos '}
          <ChevronUp />
        </Button>
      </div>
    </>
  );
};

export default Description;
